module.exports = __webpack_public_path__ + "img/banner3.c5091136.jpg";